import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';

export default class SgQuickQuoteService {
    static getAccountHolderData(id, productCode, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('quote'),
            'getAccountHolderDataForQuickQuote', [id, productCode], additionalHeaders);
    }

    static checkQuickQuoteEligibility(id, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('quote'),
            'checkQuickQuoteEligibility', [id], additionalHeaders);
    }

    static getQuickToFullQuoteLink(productCode, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('quote'),
            'getQuickToFullQuoteLink', [productCode], additionalHeaders);
    }

    static getQuickToFullQuoteRetrievalLink(productCode, id = '', additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('quote'),
            'getQuickToFullQuoteRetrievalLink', [productCode, id], additionalHeaders);
    }
}
